import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import HomepageHighlightedMember from './HomepageHighlightedMember'; // @ts-expect-error ts-migrate(7016) NOFIX

import avatarImage from 'bender-url!../../../../images/highlightedMembers/kieran-flanagan.png';
export default function KieranFlanagan({
  avatarSize
}) {
  return /*#__PURE__*/_jsx(HomepageHighlightedMember, {
    displayName: "Kieran Flanagan",
    roleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.homepage.memberHighlight.members.kieranFlanagan.role"
    }),
    avatarSrc: avatarImage,
    avatarSize: avatarSize
  });
}